import { ICON_BY_CATEGORY, IconConfig } from "@app/analytics/components/Icons";
import type {
  MeetingReportFeedItemDataAffectiveMetrics,
  MeetingReportFeedItemDataTranscriptMetrics,
} from "@app/analytics/Home/types";

export const SCORE_LABELS: {
  [key in keyof MeetingReportFeedItemDataAffectiveMetrics]: string;
} = {
  readScore: "Read Score",
  engagement: "Engagement",
  sentiment: "Sentiment",
};

export const GPT_ENTITY_CONFIG: {
  [key in keyof MeetingReportFeedItemDataTranscriptMetrics]: {
    label: string;
    icon: IconConfig;
  };
} = {
  numTopics: {
    label: "Topic",
    icon: ICON_BY_CATEGORY.topics,
  },
  numActionItems: {
    label: "Action Item",
    icon: ICON_BY_CATEGORY.action_items,
  },
  numKeyQuestions: {
    label: "Key Question",
    icon: ICON_BY_CATEGORY.key_questions,
  },
};

export const SCORE_METRICS = Object.keys(
  SCORE_LABELS
) as (keyof MeetingReportFeedItemDataAffectiveMetrics)[];

export const GPT_ENTITY_KEYS = Object.keys(
  GPT_ENTITY_CONFIG
) as (keyof MeetingReportFeedItemDataTranscriptMetrics)[];
